// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__R6r9-","left":"Virtual_left__KCzhh","wrapper":"Virtual_wrapper__VMP79"};